// frontend/src/components/Download.js

import * as React from 'react';
import { useState, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react'; // Corrected import: use named export QRCodeCanvas
import {
  isMobile,
  isTablet,
  isBrowser,
  deviceType, // Provides 'mobile', 'tablet', 'desktop'
  osName,
  browserName,
} from 'react-device-detect';

const Download = () => {
  // Create a ref to access the QRCodeCanvas component's instance (which holds the canvas)
  const qrCodeCanvasRef = useRef(null); 

  // IMPORTANT: This URL MUST match where your backend server's '/download' endpoint is hosted.
  // This is the data encoded in the QR code.
  const [qrCodeValue] = useState('https://data.pauser.health/download'); // <- Update this when deployed!
  const [detectedDevice, setDetectedDevice] = useState(null);

  // Function to detect device on click (for display on this frontend page)
  const handleClick = () => {
    let type = 'Unknown Device';
    if (isMobile) {
      type = 'Mobile Phone';
    } else if (isTablet) {
      type = 'Tablet';
    } else if (isBrowser) {
      type = 'Desktop/Laptop';
    }
    
    setDetectedDevice({
      type: type,
      rawType: deviceType,
      os: osName,
      browser: browserName,
    });

    console.log('Device detected on frontend click:', {
      type: type,
      rawType: deviceType,
      os: osName,
      browser: browserName,
    });
  };

  // Function to handle QR code download as an image
  const downloadQrCode = () => {
    // Access the canvas element directly from the ref's current property
    const canvas = qrCodeCanvasRef.current; 
      
    if (canvas) {
      // Convert the canvas content to a PNG data URL
      const pngUrl = canvas.toDataURL('image/png'); 
      
      // Create a temporary anchor (<a>) element
      const downloadLink = document.createElement('a'); 
      downloadLink.href = pngUrl; // Set the href to the image data URL
      downloadLink.download = `pauser-app-qrcode-${Date.now()}.png`; // Set a default filename
      
      // Append the link to the document body, click it, and then remove it
      document.body.appendChild(downloadLink); 
      downloadLink.click(); 
      document.body.removeChild(downloadLink);
    } else {
      console.error("Canvas element not found for QR code. Cannot download.");
    }
  };

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-4"
      onClick={handleClick} // This will trigger client-side detection for display
    >
      <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-xl w-full max-w-md">
        <h2 className="text-3xl font-bold mb-6 text-center text-gray-900 dark:text-gray-100">
          Download Our App
        </h2>

        {/* Display Detected Device Type on Frontend */}
        {detectedDevice && (
          <div className="mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-md text-blue-800 dark:text-blue-200 text-sm">
            <p className="font-semibold mb-1">Device Information (from your browser):</p>
            <p><strong>Type:</strong> {detectedDevice.type} ({detectedDevice.rawType})</p>
            <p><strong>OS:</strong> {detectedDevice.os}</p>
            <p><strong>Browser:</strong> {detectedDevice.browser}</p>
          </div>
        )}

        {/* QR Code Display - now using QRCodeCanvas */}
        <div 
          className="flex flex-col items-center justify-center p-4 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-700"
        >
          <p className="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-200">Scan to Download:</p>
          
          <QRCodeCanvas // Changed from QRCode
            value={qrCodeValue} // The QR code points to your backend's /download endpoint
            size={256} // Size in pixels
            level="H" // Error correction level
            bgColor="#ffffff" // Background color of QR code
            fgColor="#000000" 
            includeMargin = {true}// Foreground color of QR code
            ref={qrCodeCanvasRef} // Attach the ref directly to QRCodeCanvas
          />

          <p className="text-sm text-gray-600 dark:text-gray-400 mt-4 text-center break-all">
            Link: {qrCodeValue}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
            (Scanning this QR code will automatically redirect you to the correct app store.)
          </p>
        </div>

        {/* Download Button for QR Code */}
        <button
          onClick={downloadQrCode}
          className="mt-6 w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Download QR Code as Image
        </button>
      </div>
    </div>
  );
};

export default Download;